import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  pageWrapper: {
    backgroundColor: neutrals.coldGrays.pearl,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    position: 'absolute',
    zIndex: 100,
  },
  imageLoadingPlaceholderContainer: {
    position: 'relative',
    width: 300,
    height: 120,
  },
  sentencesContainer: {
    position: 'absolute',
    top: 120,
    width: 300,
  },
  sentencesText: {
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 24,
    color: brand.main.variations['darkerWater-2'],
  },
});
